import Component from '@glimmer/component'
import { action } from '@ember/object'
import { on } from '@ember/modifier'

export interface ItemReference {
  hasData: boolean
  mapNumber: number
}

interface Args {
  item: ItemReference
  currentItemId?: number
  changeItem?: (itemId: number) => void
}

interface Signature {
  Element: HTMLButtonElement
  Args: Args
}

export class MapSelectorItem extends Component<Signature> {
  get hasData() {
    return this.args.item.hasData
  }

  get hasNoData() {
    return !this.hasData
  }

  get isSelected() {
    return this.args.currentItemId === this.args.item.mapNumber
  }

  @action
  switchActiveItem() {
    if (this.hasData && this.args.changeItem) {
      this.args.changeItem(this.args.item.mapNumber)
    }
  }

  <template>
    <button
      data-test-map-selector-item={{@item.mapNumber}}
      type="button"
      class="border-color-dusty-black-100 inline-block w-10 border-l p-3 text-center
        {{if this.hasData 'text-black' 'text-dusty-black-100 cursor-not-allowed'}}
        {{if this.isSelected 'bg-oceany-blue-300 text-white' 'bg-white'}}"
      ...attributes
      disabled={{this.hasNoData}}
      {{on "click" this.switchActiveItem}}
    >
      {{@item.mapNumber}}
    </button>
  </template>
}

export default MapSelectorItem
